module.exports = __webpack_public_path__ + "img/logo-Cofidis-Pay_4xcb.e9ad7529.png";